import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '12148509000';
  const message = encodeURIComponent('Hi! I have a question.');
  const url = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 bg-[#25D366] hover:bg-[#20bd5a] w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-button"
    >
      <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.914 15.914 0 0016.004 32C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.302 22.602c-.39 1.1-1.932 2.014-3.166 2.28-.846.18-1.95.324-5.668-1.218-4.762-1.97-7.826-6.81-8.064-7.124-.23-.314-1.932-2.572-1.932-4.904 0-2.332 1.218-3.478 1.652-3.952.39-.428 1.024-.624 1.632-.624.196 0 .372.01.53.018.468.02.702.048.992.766.39.95 1.342 3.282 1.46 3.52.118.24.236.55.08.864-.148.322-.278.466-.516.738-.24.272-.466.48-.706.774-.222.258-.47.534-.194 1.002.278.46 1.234 2.034 2.65 3.296 1.82 1.622 3.282 2.146 3.788 2.364.39.168.704.04.966-.168.272-.228.578-.604.888-.978.224-.27.504-.302.824-.168.328.128 2.064.974 2.42 1.152.356.178.594.266.682.414.086.148.086.864-.304 1.964z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
